<template>
  <div class="stats-row mt-3">

    <!-- Contractions Logged -->
    <div class="stat-card position-relative" @click="redirectToHealingDashboard">
      <div class="stat-card__accent"></div>
      <div class="stat-card__icon-wrap">
        <contraction-svg></contraction-svg>
      </div>
      <div class="stat-card__body">
        <div class="stat-card__label">Contractions Logged</div>
        <template v-if="stats">
          <div class="stat-card__combined">
            <span class="combined-user">{{ stats.user.contractions.total_logged }}</span>
            <span class="combined-community"><i class="fas fa-users"></i> {{ stats.total.contractions.total_logged }}</span>
          </div>
          <div class="stat-card__value">{{ stats.user.contractions.total_logged }}</div>
          <div class="stat-card__community">
            <i class="fas fa-users mr-1"></i><span class="community-label">Community: </span>{{ stats.total.contractions.total_logged }}
          </div>
        </template>
        <i v-else class="fas fa-spinner gold fa-spin mt-2"></i>
      </div>
    </div>

    <!-- Contractions Processed -->
    <div class="stat-card position-relative" @click="redirectToHealingDashboard">
      <div class="stat-card__accent"></div>
      <div class="stat-card__icon-wrap">
        <i class="fas fa-check-double"></i>
      </div>
      <div class="stat-card__body">
        <div class="stat-card__label">Contractions Processed</div>
        <template v-if="stats">
          <div class="stat-card__combined">
            <span class="combined-user">{{ stats.user.contractions.total_processed }}</span>
            <span class="combined-community"><i class="fas fa-users"></i> {{ stats.total.contractions.total_processed }}</span>
          </div>
          <div class="stat-card__value">{{ stats.user.contractions.total_processed }}</div>
          <div class="stat-card__community">
            <i class="fas fa-users mr-1"></i><span class="community-label">Community: </span>{{ stats.total.contractions.total_processed }}
          </div>
        </template>
        <i v-else class="fas fa-spinner gold fa-spin mt-2"></i>
      </div>
    </div>

    <!-- Supported Others -->
    <div class="stat-card position-relative" @click="redirectToHealingDashboard">
      <div class="stat-card__accent"></div>
      <div class="stat-card__icon-wrap">
        <i class="fas fa-hands-helping"></i>
      </div>
      <div class="stat-card__body">
        <div class="stat-card__label">Supported Others</div>
        <template v-if="stats">
          <div class="stat-card__combined">
            <span class="combined-user">{{ stats.user.supported_others }}</span>
            <span class="combined-community"><i class="fas fa-users"></i> {{ stats.total.supported_others }}</span>
          </div>
          <div class="stat-card__value">{{ stats.user.supported_others }}</div>
          <div class="stat-card__community">
            <i class="fas fa-users mr-1"></i>
            <span class="community-label">Community: </span>{{ stats.total.supported_others }}
          </div>
        </template>
        <i v-else class="fas fa-spinner gold fa-spin mt-2"></i>
      </div>
    </div>

  </div>
</template>

<script>
import ContractionSvg from "@/components/svg/ContractionSvg.vue";

export default {
  components: {
    ContractionSvg
  },
  props: {
    stats: {
      type: Object,
      default: null,
    }
  },
  methods: {
    redirectToHealingDashboard() {
      this.$router.push('/contractions')
    },
  }
}
</script>

<style scoped>
.stats-row {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
}


/* ── Card shell ── */
.stat-card {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border-radius: 14px;
  padding: 12px 20px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
  border: 1px solid rgba(214, 182, 116, 0.18);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(214, 182, 116, 0.18);
}

/* coloured left accent bar */
.stat-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 14px 0 0 14px;
  background: linear-gradient(180deg, #d6b674 0%, #c4a55a 100%);
}

/* ── Icon circle ── */
.stat-card__icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(214, 182, 116, 0.35);
}


.stat-card__icon-wrap i {
  color: #fff;
  font-size: 1.2rem;
}

::v-deep .stat-card__icon-wrap svg {
  width: 28px;
  height: 28px;
  stroke: white;
}

::v-deep .stat-card__icon-wrap svg path {
  stroke: white;
}

/* ── Text content ── */
.stat-card__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-card__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stat-card__value {
  font-size: 1.8rem;
  font-weight: 800;
  color: #d6b674;
  line-height: 1.1;
}

.stat-card__community {
  font-size: 0.72rem;
  color: #aaa;
  margin-top: 4px;
  background: rgba(214, 182, 116, 0.1);
  border-radius: 20px;
  padding: 2px 8px;
  width: max-content;
}

/* Combined block — desktop: hidden */
.stat-card__combined {
  display: none;
}

.combined-user {
  font-size: 1.1rem;
  font-weight: 800;
  color: #d6b674;
  line-height: 1;
}

.combined-sep {
  font-size: 0.9rem;
  font-weight: 400;
  color: #ccc;
  margin: 0 2px;
  line-height: 1;
}

.combined-community {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.5rem;
  font-weight: 500;
  color: #aaa;
  background: rgba(214, 182, 116, 0.12);
  border-radius: 20px;
  padding: 2px 5px;
}

@media (max-width: 991px) {
  .stats-row {
    gap: 8px;
    margin-top: 0 !important;
  }
  .stat-card {
    min-width: 0;
    flex: 1;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px 4px;
    gap: 4px;
    overflow: visible;
    box-shadow: none;
  }
  /* hide icon on mobile */
  .stat-card__icon-wrap {
    display: none;
  }
  .stat-card__body {
    flex-direction: column;
    align-items: center;
    gap: 2px;
    min-width: 0;
    width: 100%;
  }
  /* show combined block, hide separate value + community */
  .stat-card__combined {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    order: -1;
    margin-bottom: 8px;
  }
  .stat-card__value {
    display: none;
  }
  .stat-card__community {
    display: none;
  }
  .stat-card__label {
    font-size: 0.7rem;
    font-weight: 400;
    color: #999;
    text-transform: none;
    letter-spacing: 0;
    width: 100%;

    @media screen and (max-width: 450px) {
      max-width: 85px;
    }
  }
}

@media (max-width: 500px) {
  .stat-card__accent {
    display: none;
  }

  .stats-row {
    gap: 4px;
  }
}
</style>
